"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "5", cy: "12", r: "2.5" },
        React.createElement("animate", { accumulate: "none", additive: "replace", attributeName: "fill-opacity", begin: "0ms", calcMode: "linear", dur: "1s", fill: "remove", repeatCount: "indefinite", restart: "always", values: "1;.2;1" })),
    React.createElement("circle", { cx: "12", cy: "12", r: "2.5" },
        React.createElement("animate", { accumulate: "none", additive: "replace", attributeName: "fill-opacity", begin: "100ms", calcMode: "linear", dur: "1s", fill: "remove", repeatCount: "indefinite", restart: "always", values: "1;.2;1" })),
    React.createElement("circle", { cx: "19", cy: "12", r: "2.5" },
        React.createElement("animate", { accumulate: "none", additive: "replace", attributeName: "fill-opacity", begin: "300ms", calcMode: "linear", dur: "1s", fill: "remove", repeatCount: "indefinite", restart: "always", values: "1;.2;1" }))), "LoadingDots");
//# sourceMappingURL=LoadingDots.js.map